let language = {
    "LBL_HOME":"Home",
    "LBL_ADD_RELATED_LINK": "Add RelatedLink",
    "LBL_VIEW_RELATED_LINK": "View RelatedLink",
    "LBL_RELATED_LINK_NAME": "RelatedLink Name",
    "LBL_CREATED_BY": "Created By",
    "LBL_PARENT_ID": "Parent ID",
    "LBL_PARENT_TYPE": "Parent Type",
    "LBL_DESCRIPTION":"Description",
    "LBL_CREATE_DATE":"Date Created",
    "LBL_ENTERED":"Date Entered",
    "LBL_MODIFIED_DATE":"Date Modified",
    "LBL_DOWNLOAD_ONE":"Download 1",
    "LBL_DOWNLOAD_TWO":"Download 2",
    "LBL_EDIT":"Edit",
    "LBL_DELETE":"Delete",
}

export default language;